module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v("NEW YORK UNIVERSITY PRESS"), _c('br'), _vm._v("New York and London"), _c('br'), _c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.nyupress.org",
      "target": "_blank"
    }
  }, [_vm._v("www.nyupress.org")])])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("© 2007 by New York University"), _c('br'), _vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data"), _c('br'), _vm._v("Schroth, Raymond A."), _c('br'), _vm._v("The American Jesuits: a history / Raymond A. Schroth."), _c('br'), _vm._v("p. cm."), _c('br'), _vm._v("Includes bibliographical references and index."), _c('br'), _vm._v("ISBN-13: 978-0-8147-4025-5 (cloth: alk. paper)"), _c('br'), _vm._v("ISBN-10: 0-8147-4025-1 (cloth: alk. paper)"), _c('br'), _vm._v("1. Jesuits—United States—History. I. Title."), _c('br'), _vm._v("BX3708.S37 2007"), _c('br'), _vm._v("271’.53073—dc22            2007016965")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("New York University Press books are printed on acid-free paper, and their binding materials are chosen for strength and durability.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Manufactured in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("10 9 8 7 6 5 4 3 2 1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aefbb34e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 63
// module chunks = 0